/**
 * Buzz reel rail: horizontal scroll on mobile and desktop,
 * while still letting a tap play the Instagram embed.
 */
(function () {
  var SELECTOR = '.magio-home-buzz__rail, .magio-salon-buzz__rail';

  function frames(rail) {
    return rail.querySelectorAll('iframe');
  }

  function setFrameEvents(rail, enabled) {
    frames(rail).forEach(function (frame) {
      frame.style.pointerEvents = enabled ? 'auto' : 'none';
    });
  }

  function bindRail(rail) {
    if (!rail || rail.dataset.magioBuzzPan === '1') return;
    rail.dataset.magioBuzzPan = '1';

    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var dragging = false;

    rail.addEventListener(
      'wheel',
      function (event) {
        if (rail.scrollWidth <= rail.clientWidth + 2) return;
        var delta = Math.abs(event.deltaY) > Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
        if (!delta) return;
        rail.scrollLeft += delta;
        event.preventDefault();
      },
      { passive: false }
    );

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
      dragging = false;
    });

    rail.addEventListener('pointermove', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var dx = event.clientX - startX;
      if (!dragging && Math.abs(dx) > 8) {
        dragging = true;
        setFrameEvents(rail, false);
        try {
          rail.setPointerCapture(pointerId);
        } catch (err) {}
      }
      if (!dragging) return;
      rail.scrollLeft = startScroll - dx;
      event.preventDefault();
    });

    function endPointer(event) {
      if (pointerId === null || (event && event.pointerId !== pointerId)) return;
      pointerId = null;
      dragging = false;
      setFrameEvents(rail, true);
    }

    rail.addEventListener('pointerup', endPointer);
    rail.addEventListener('pointercancel', endPointer);
    rail.addEventListener('lostpointercapture', function () {
      pointerId = null;
      dragging = false;
      setFrameEvents(rail, true);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(bindRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
